// extracted by mini-css-extract-plugin
export default {"Text":"Text__W8R1i"};